// extracted by mini-css-extract-plugin
export default {"container":"ForgotPassword_container__2E-Zh","wrapperInput":"ForgotPassword_wrapperInput__CU30L","wrapperImg":"ForgotPassword_wrapperImg__Fw8av"};